import { connect } from 'react-redux'
import Fitting1OrdererUploadComponent from '../components/Fitting1OrdererUploadComponent.jsx';
import {
  uploadOrdererAppData,
  clearFitting1Alert,
  deleteFittingAppRecordByDuration
} from '../actions';

const mapStateToProps = (state) => ({
  orderId: state.getIn(['fitting1Reducer', 'orderId']),
  alertStyle: state.getIn(['fitting1Reducer', 'alertStyle']),
  alertMessage: state.getIn(['fitting1Reducer', 'alertMessage']),
})

const mapDispatchToProps = (dispatch) => ({
  uploadOrderer: (payload, uploadOrdererFile) => {
    dispatch(uploadOrdererAppData(payload, uploadOrdererFile));
  },
  clearOrdererAlert: () => {
    dispatch(clearFitting1Alert());
  },
  deleteFittingRecordByDuration: (payload) => {
    dispatch(deleteFittingAppRecordByDuration(payload));
  },
})

const Fitting1OrdererUploadContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Fitting1OrdererUploadComponent)

export default Fitting1OrdererUploadContainer;


// WEBPACK FOOTER //
// ./src/containers/Fitting1OrdererUploadContainer.jsx